module.exports = __webpack_public_path__ + "img/icon-0.2ea1663d.png";